/* eslint-disable no-undef */
import Api from '@/services/Api'

export default {
  startSimulation (unitId) {
    return Api().post('simulationstart', {unitId: unitId})
  },
  getStatus (unitId) {
    return Api().get('simulationstatus', {unitId: unitId})
  }
}



// WEBPACK FOOTER //
// ./src/services/Simulation.js